import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizedStringPipe } from '../../localized-string.pipe';

export interface Tile {
  id: string | number;
  subTitle?: string;
  preview?: boolean;
  dynamic?: boolean;
  payload?: any;
  url?: string;
  access_roles?: string[];
  visible_roles?: string[];
  subTiles?: Tile[];
  iconName?: string;
  titleKey?: string;
  ionBadgeIcon?: string;
  ionBadgeIconClass?: string;
  ionBadgeColor?: string;
  action?: (initiator: object) => Observable<any>;
  modal?: boolean;
}

@Component({
    selector: 'app-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    imports: [IonicModule, TranslatePipe, LocalizedStringPipe]
})
export class TileComponent {
  @Input() tile: Tile;
  
  @Input() badge: string | number | null = null;
  @Input() icon: string | null = null;
  @Input() isPreview: boolean = false;
  @Input() isDynamic: boolean = false;
  @Input() isURL: boolean = false;
  
  public missingIcon: boolean = false;

  constructor() {}

  public iconPath(): string {
    if (this.tile.iconName) {
      return `assets/tile-icons/${this.tile.iconName}.svg`;
    }
    return `assets/tile-icons/${this.tile.id}.svg`;
  }

  public titleTranslateKey() {
    if (this.tile.titleKey) {
      return this.tile.titleKey;
    }
    return `${this.tile.id}.title`;
  }

  public handleImageError(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
    this.missingIcon = true;
  }
}
